import React, { useContext, useState } from 'react';
import snakecaseKeys from 'snakecase-keys';
import { useDispatch } from 'react-redux';
import { sendAlert } from '../../../../actions/utils';
import ReliquidationBalancesForm from './ReliquidationBalancesForm';
import { PayrollProcessContext } from '../../../RemunerationProcesses/context/PayrollProcessProvider';
import { createReliquidationBalancesRequest } from '../../../../requests/reliquidationBalances';

const ReliquidationBalances = ({ setActiveComponent }) => {
  const dispatch = useDispatch();
  const [moreData, setMoreData] = useState(false);
  const { reliquidationProcess } = useContext(PayrollProcessContext);

  const handleSuccessAction = (message, resetForm, setFieldValue) => {
    dispatch(sendAlert({ kind: 'success', message }));
    setMoreData(!moreData);
    setFieldValue('payrollBalance[employeeIds]', []);
    resetForm();
    setActiveComponent('ReliquidationBalancesTable');
  };

  const handleFailureRequest = error => {
    dispatch(sendAlert({ kind: 'error', message: error.response?.data?.message }));
  };

  const handleCreate = (values, setSubmitting, resetForm, setFieldValue) => {
    const params = snakecaseKeys(values);
    createReliquidationBalancesRequest({
      dispatch,
      params,
      successCallback: () => {
        handleSuccessAction('Conceptos cargados exitosamente!', resetForm, setFieldValue);
      },
      failureCallback: handleFailureRequest,
      callback: () => setSubmitting(false)
    });
  };

  return (
    <>
      <ReliquidationBalancesForm
        action="new"
        formRequest={handleCreate}
        reliquidationProcess={reliquidationProcess}
        setActiveComponent={setActiveComponent}
      />
    </>
  );
};

export default ReliquidationBalances;
